import { USER } from 'constants/permissionConstants';
import React, { Dispatch } from 'react';
import { Dropdown, Menu, Tag } from 'antd';
import { BiDotsVerticalRounded } from 'react-icons/bi';
import { ColumnsType } from 'antd/lib/table';
import { UserType } from 'services/users';
import { getColumnHtml } from 'helpers/reactutils';
import { ChangeStatusLinkWithPermission, EditLinkWithPermission } from './withPermissionComponents';

type OpenUpdateUserStatusModalType = (id: string, firstName: string, status: boolean) => void;

type UserTableColumnsProps = {
  editPermission: boolean;
  changeStatusPermission: boolean;
  setEditPermission: Dispatch<boolean>;
  setChangeStatusPermission: Dispatch<boolean>;
  openUpdateUserStatusModal: OpenUpdateUserStatusModalType;
};

const UserTableColumns = (props: UserTableColumnsProps): ColumnsType<UserType> => {
  const {
    editPermission,
    changeStatusPermission,
    setEditPermission,
    setChangeStatusPermission,
    openUpdateUserStatusModal,
  } = props;
  return [
    {
      title: ({ sortColumns }) => getColumnHtml(sortColumns, 'firstName', 'First Name'),
      dataIndex: 'firstName',
      sorter: true,
      width: '20%',
      key: 'firstName',
    },
    {
      title: ({ sortColumns }) => getColumnHtml(sortColumns, 'lastName', 'Last Name'),
      dataIndex: 'lastName',
      sorter: true,
      width: '20%',
      key: 'lastName',
    },
    {
      title: ({ sortColumns }) => getColumnHtml(sortColumns, 'email', 'Email'),
      dataIndex: 'email',
      sorter: true,
      width: '20%',
      key: 'email',
    },
    {
      title: ({ sortColumns }) => getColumnHtml(sortColumns, 'phoneNumber', 'Phone'),
      dataIndex: 'phoneNumber',
      key: 'phoneNumber',
      width: '12%',
      sorter: true,
    },
    {
      title: 'User Role',
      dataIndex: ['role', 'roleName'],
      key: 'role',
      width: '12%',
    },
    {
      title: ({ sortColumns }) => getColumnHtml(sortColumns, 'isActive', 'Status'),
      dataIndex: 'isActive',
      key: 'isActive',
      sorter: true,
      render: (tag: React.Key | null | undefined) => {
        const color = tag ? 'green' : 'volcano';
        return (
          <Tag color={color} key={tag}>
            {tag ? 'Active' : 'Inactive'}
          </Tag>
        );
      },
    },
    {
      title: 'Action',
      dataIndex: 'id',
      key: 'action',
      render: (text: string, record: UserType) => (
        <Dropdown
          overlay={
            <Menu key={`user-action-menu-${record.id}`} className="actionDropDown">
              <Menu.Item key={`edit-user-${record.id}`}>
                <EditLinkWithPermission
                  disabled={!editPermission}
                  record={record}
                  text={text}
                  componentPermissions={[USER.EDIT]}
                  setPermission={setEditPermission}
                />
              </Menu.Item>
              <ChangeStatusLinkWithPermission
                disabled={!changeStatusPermission}
                record={record}
                text={text}
                openUpdateUserStatusModal={openUpdateUserStatusModal}
                componentPermissions={[USER.ACTIVATE]}
                setPermission={setChangeStatusPermission}
              />
            </Menu>
          }>
          <div className="icon-set">
            <BiDotsVerticalRounded size={24} />
          </div>
        </Dropdown>
      ),
    },
  ];
};

export default UserTableColumns;
